import { TableColumnType } from 'src/types/table';

export type ExportDataType = 'packages' | 'packagesProducts';

export const REQUIRED_EXPEDITION_PACKAGES_GRID_COLUMNS = ['ID', 'ID_ORDER'];

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'id',
        defaultShow: false,
    },
    {
        key: 'ID_ORDER',
        label: 'orderId',
        type: 'id',
        defaultShow: true,
    },
    {
        key: 'ESHOP_ORDER_ID',
        label: 'eshopOrderId',
        defaultShow: true,
        disableSort: true,
    },
    {
        key: 'EXP_PCKG',
        label: 'expeditionPackage',
        defaultShow: true,
    },
    {
        key: 'WIDTH',
        label: 'width',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'HEIGHT',
        label: 'height',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'LENGTH',
        label: 'length',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'WEIGHT',
        label: 'weight',
        type: 'number-filter',
        defaultShow: true,
    },
    {
        key: 'TRACKING_NUMBER',
        label: 'trackingNumber',
        defaultShow: true,
    },
    {
        key: 'PCKG_SKU',
        label: 'packageSku',
        defaultShow: true,
    },
    {
        key: 'EXP_PAL',
        label: 'expPal',
        defaultShow: true,
    },
    {
        key: 'PALLET_SKU',
        label: 'palletSku',
        defaultShow: true,
    },
    {
        key: 'SSCC_NUMBER',
        label: 'sscc',
        defaultShow: true,
    },
    {
        key: 'CREATED_AT',
        label: 'createdAt',
        defaultShow: true,
        type: 'dateTime',
    },
    {
        key: 'UPDATED_AT',
        label: 'updatedAt',
        type: 'dateTime',
        defaultShow: false,
    },
];

export const extendProductColumns: TableColumnType[] = [
    { key: 'SKU', label: 'productSKU' },
    { key: 'NAME', label: 'productName' },
    { key: 'EAN', label: 'productEAN' },
    { key: 'COUNT', label: 'productCount' },
    { key: 'SERIAL_NUMBER', label: 'productSerialNumber' },
];
